import React from 'react'
import CustomerList from '../CustomerList'

function School() {
  return (
    <div>
      <CustomerList />
    </div>
  )
}

export default School
